import Bugsnag from '@bugsnag/js';
import APP_VERSION from '../version';

const bugsnagClient = Bugsnag.start({
  apiKey: 'c7f93d439e27ec8057a090d700e54e35', // public api key
  appType: 'web',
  releaseStage: process.env.NODE_ENV,
  appVersion: APP_VERSION,
});
// console.log("It's initialized?", bugsnagClient)
// bugsnagClient.notify(new Error("test error from App.js init 10:47"));
// console.log("Notified...")

// const bugsnag_log = (e, context = "Unknown", severity = "error") => {
//   if (!bugsnagClient || !e) return;
//   console.log("SENDING ERROR?", e, "is error instance?", e instanceof Error)

//   // error must be instance of error.
//   const err = e instanceof Error ? e : new Error(e.message || 'Unknown error');
//   console.log("error going to bugsnag?", err)
//   bugsnagClient.notify(err, event => {
//     event.context = context;
//     event.severity = severity;
//     event.addMetadata("custom", {
//       originalPayload: e,
//       message: err,
//       location: window?.location?.href,
//     });
//   });

// };

const safeStringify = (obj) => {
  try {
    return JSON.stringify(obj);
  } catch {
    return '[Unserializable Object]';
  }
};

export const bugsnag_log = (
  e,
  {
    context        = 'Unknown',      // e.g. the GraphQL field or function name
    severity       = 'error',        // one of 'error'|'warning'|'info'
    graphqlVars    = null,           // the variables you sent
    backendStack   = null            // e.g. your Ruby trace array
  } = {}
) => {
  if (!bugsnagClient || !e) return;
  const err = e instanceof Error ? e : new Error(e.message || String(e));

  bugsnagClient.notify(err, event => {
    // top‐level context
    event.context = context;
    event.severity = severity;

    // attach your GraphQL payload
    if (graphqlVars) {
      event.addMetadata('graphql', {
        operation: context,
        variables:  graphqlVars
      });
    }

    // bubble through any back‐end trace
    if (backendStack && Array.isArray(backendStack)) {
      event.addMetadata('backend', {
        ruby_stack: backendStack.join('\n')
      });
    }

    // you can keep your old “custom” section too
    event.addMetadata('custom', {
      originalError: safeStringify(e),
      originalErrorString: e?.message || String(e),
      url: window.location.href
    });
  });
};

